import { StoreType } from '@tock/shared/utils/connect';

export const getSearch = (state: StoreType) => state.search;
export const getCurrentSearch = (state: StoreType) => state.search.currentSearch;
export const getQueryResultMatches = (state: StoreType) => state.search.queryResults.matches;
